export default __webpack_public_path__ + "media/calmerCanineMockup.6174349a.mp4";